import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  ThinDropdown,
  ThinTextField,
  AddButton,
  ThinDropdownWithSearch,
  BackButton,
} from "../../common/GeneralComponent";
import { fetchData } from "../../../utils/functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loader from "../../../components/partials/Loader";

const EditTehsile = () => {
  const { id } = useParams();
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(true);
  const [tehsile, setTehsile] = useState({
    tehsil_name: "",
    district_id: null,
    status: 1,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetch districts + tehsil
  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoader(true);
      try {
        // Fetch districts
        const districtsResponse = await fetchData(
          "districts",
          "GET",
          null,
          {},
          {},
          navigate,
          "/districts",
          dispatch
        );
        setFilteredDistricts(districtsResponse?.data || []);

        // Fetch tehsil data
        const tehsilResponse = await fetchData(
          "all-tehsils",
          "GET",
          null,
          {},
          { tehsil_id: id },
          navigate,
          "/tehsils",
          dispatch
        );

        const tehsilData = tehsilResponse?.data?.[0];
        if (tehsilData) {
          setTehsile({
            tehsil_name: tehsilData?.tehsil_name || "",
            district_id: tehsilData?.district_id || null,
            status: tehsilData?.status !== undefined ? tehsilData.status : 1,
          });
        }
      } catch (error) {
        console.error("Error fetching tehsil:", error);
        toast.error("Failed to load tehsil data");
      } finally {
        setLoader(false);
      }
    };

    if (id) fetchDataAsync();
  }, [id, navigate, dispatch]);

  const validationSchema = Yup.object({
    tehsil_name: Yup.string()
      .max(500, "Tehsil Name cannot exceed 500 characters")
      .required("Tehsil Name is required"),
    district_id: Yup.string().required("District is required"),
    status: Yup.number().required("Status is required"),
  });

  const formik = useFormik({
    initialValues: tehsile,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const data = {
          tehsil_id: id,
          tehsil_name: values.tehsil_name,
          district_id: values.district_id,
          status: values.status,
        };

        const response = await fetchData(
          "tehsils",
          "PUT",
          data,
          {},
          {},
          navigate,
          "/tehsils",
          dispatch
        );
        toast.success(response?.message || "Tehsil updated successfully");
        navigate("/tehsils");
      } catch (error) {
        console.error("Error updating tehsil:", error);
        toast.error(error?.message || "Failed to update tehsil");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div>
      {loader && <Loader />}
      <BackButton text="Back" to="/tehsils" />
      <h1 className="text-black text-[1.475rem] text-Black font-[Bold] ">
        Edit Tehsil
      </h1>

      <div className="bg-white rounded-lg shadow w-full my-5">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b mb-4">
          <h1 className="lg:text-[0.875rem] text-[13px] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Edit Tehsil
          </h1>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="grid lg:grid-cols-2 gap-4 p-4 my-4 cols-3">
            <ThinTextField
              id="tehsil_name"
              label="Tehsil Name"
              placeholder="Enter Tehsil Name"
              type="text"
              value={formik.values.tehsil_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.tehsil_name && formik.errors.tehsil_name}
              helperText={
                formik.touched.tehsil_name && formik.errors.tehsil_name
              }
              maxLength={500}
            />

            <ThinDropdownWithSearch
              label="District"
              id="district-dropdown"
              options={
                filteredDistricts?.map((district) => ({
                  value: district.District_Id || district.district_id,
                  label: district.District_Name || district.district_name,
                })) || []
              }
              value={formik.values.district_id}
              onChange={(value) => formik.setFieldValue("district_id", value)}
              error={formik.touched.district_id && formik.errors.district_id}
              helperText={
                formik.touched.district_id && formik.errors.district_id
              }
            />

            <ThinDropdown
              label="Status"
              id="status-dropdown"
              options={[
                { value: 1, label: "Active" },
                { value: 0, label: "In-Active" },
              ]}
              value={formik.values.status}
              onChange={(e) => formik.setFieldValue("status", e.target.value)}
              error={formik.touched.status && formik.errors.status}
              helperText={formik.touched.status && formik.errors.status}
            />

            <div className="w-full float-left p-4">
              <AddButton
                text="Submit"
                type="Submit"
                isLoading={isSubmitting}
                disabled={formik.isSubmitting}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTehsile;
